<template>
  <div style="padding:20px;">
    <el-row>
      <el-col :span="24">
        <el-button
            style="padding: 0; margin: 20px"
            type="text"
            icon="el-icon-back"
            @click="backPrePage()"
        >
          返回
        </el-button>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-form ref="form" :model="form" label-width="150px" :disabled="formLoading">
        <el-row>
          <el-col :span="24">
            <el-form-item label="标题" prop="module_name">
              <el-input
                  v-model="form.title"
                  maxlength="20"
                  show-word-limit
                  style="width:33%"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button type="primary" :loading="onSaveLoading" @click="onSave">保存</el-button>
        </el-form-item>
      </el-form>

    </el-row>
  </div>
</template>
<script>
import {
  getModuleInfo, updateModuleInfo
} from "@/api/mall";

export default {
  data: function () {
    return {
      id: '',
      info: {},
      form: {
        module_name: '',
      },
      ossAction: "",
      formLoading: false,
      onSaveLoading: false,
    }
  },
  created: function (){
    this.id = this.$route.query.id;
    this.getModuleInfo();
  },
  methods: {
    getModuleInfo(){
      this.formLoading = true;
      getModuleInfo({id:this.id}).then(res => {
        this.form = res.data;
        this.formLoading = false;
      });
    },
    onSave() {
      this.onSaveLoading = true;
      let that = this
      updateModuleInfo(this.form).then(res => {
        that.onSaveLoading = false;
        if (res.code == 1) {
          that.$message({
            showClose: true,
            duration: 6000,
            message: '保存成功',
            type: 'success'
          });
          that.backPrePage();
        }
      });

    },
    backPrePage() {
      this.$router.go(-1);
    }
  },
}
</script>